import {
  CLEAR_IP_ACCOUNT_LOOKUP,
  IP_ACCOUNT_LOOKUP_FAILURE,
  IP_ACCOUNT_LOOKUP_REQUEST,
  IP_ACCOUNT_LOOKUP_SUCCESS,
  IP_MANAGEMENT_FAILURE,
  IP_MANAGEMENT_REQUEST,
  IP_MANAGEMENT_SUCCESS,
} from "./types";

const initialState = {
  data: {
    policy: null,
    emailProviderPolicy: null,
    overrides: [],
    blockedIps: [],
  },
  loading: true,
  loadError: "",
  saving: "",
  accountLookupLoading: false,
  accountLookupResult: null,
  accountLookupError: "",
};

const ipManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    case IP_MANAGEMENT_REQUEST:
      return {
        ...state,
        loading: action.payload === "load",
        loadError: action.payload === "load" ? "" : state.loadError,
        saving: action.payload === "load" ? "" : action.payload,
      };
    case IP_MANAGEMENT_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        loadError: "",
        saving: "",
      };
    case IP_MANAGEMENT_FAILURE:
      return {
        ...state,
        loading: false,
        loadError: action.payload.key === "load" ? action.payload.message : state.loadError,
        saving: "",
      };
    case IP_ACCOUNT_LOOKUP_REQUEST:
      return {
        ...state,
        accountLookupLoading: true,
        accountLookupResult: null,
        accountLookupError: "",
      };
    case IP_ACCOUNT_LOOKUP_SUCCESS:
      return {
        ...state,
        accountLookupLoading: false,
        accountLookupResult: action.payload,
        accountLookupError: "",
      };
    case IP_ACCOUNT_LOOKUP_FAILURE:
      return {
        ...state,
        accountLookupLoading: false,
        accountLookupResult: null,
        accountLookupError: action.payload,
      };
    case CLEAR_IP_ACCOUNT_LOOKUP:
      return {
        ...state,
        accountLookupLoading: false,
        accountLookupResult: null,
        accountLookupError: "",
      };
    default:
      return state;
  }
};

export default ipManagementReducer;
